export default async function ReportSummary(indicador, visita, tipoName) {
    return null
}
